<div class="label-section" [ngClass]="{ 'input-disabled': isDisabled }">
  <label [for]="forId">
    {{ label }}
  </label>
  @if (!isRequired && !isDisabled && !hideOptionalText) {
    <span>Frivillig</span>
  }
  @if (showIsRequiredError) {
    <span class="error-text required-text">*Påkrevd</span>
  }
  @if (labelHelpText) {
    <span class="label-help-text" [ngClass]="{ 'error-text': isErrorState }">
      {{ labelHelpText }}
    </span>
  }
</div>
<div class="input-section">
  <input
    #dateInput
    autocomplete="off"
    class="suffix-icon"
    matInput
    [attr.data-testid]="textTestId()"
    [formControl]="control"
    [id]="forId"
    [matDatepicker]="picker"
    [matDatepickerFilter]="isDateAllowedFilterFn"
    [max]="maxDate"
    [min]="minDate"
    [ngClass]="{ 'has-error': isErrorState, 'focus-input': isDatePickerOpen }"
    [placeholder]="placeholder"
    [readOnly]="readonly"
    (change)="onDateInputChanged($event)"
    (dateChange)="onDateInputChanged($event)"
  />
  <app-ice-icon-button
    class="suffix-icon"
    [iconName]="isDatePickerOpen ? IconNames.ice_close : IconNames.ice_calendar"
    [testId]="buttonTestId()"
    (clicked)="picker.open()"
  />
  <mat-datepicker #picker (closed)="toggleIsDatePickerOpen()" (opened)="toggleIsDatePickerOpen()" />
</div>

@if (isErrorState && !!errorText && !showIsRequiredError) {
  <div class="error-section">
    <mat-icon [svgIcon]="IconNames.ice_warning" />
    <span>{{ errorText }}</span>
  </div>
} @else if (!!longHelpText) {
  <div class="long-help-text">{{ longHelpText }}</div>
}
